<template>
    <div class="flex items-center justify-center min-h-screen">
        <router-view />
    </div>
</template>
